document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.js-open-sidebar')) {
    const eventElements = document.querySelectorAll('.js-open-sidebar');
    eventElements.forEach((el) => {
      el.addEventListener('click', () => {
        fetch('/get-sidebar-data/' + el.dataset.uuid)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Failed to load sidebar data');
            }
            return response.text();
          })
          .then((html) => {
            sidebar = document.querySelector('.sidebar').innerHTML = html;

            const qs = window.location.search;
            const editLink = document.querySelector('.sidebar__footer a.button--action');
            if (editLink && qs) {
              editLink.href += qs;
            }
            document.querySelectorAll('.sidebar__footer input[name="_query_string"]').forEach((input) => {
              input.value = qs.replace(/^\?/, '');
            });

            document.querySelector('.sidebar').classList.add('is-open');
            document.querySelector('.sidebar-container').classList.add('is-active');

            document.querySelector('.js-close-sidebar').addEventListener('click', () => {
              document.querySelector('.sidebar').classList.remove('is-open');
              document.querySelector('.sidebar-container').classList.remove('is-active');
            });
          })
          .catch((error) => {
            console.error(error);
          });
      });
    });
  }

  if (document.querySelector('.sidebar__body')) {
    new SimpleBar(document.querySelector('.sidebar__body'), {
      autoHide: true,
    });
  }
  if (document.querySelector('.form-select')) {
    $('.form-select:not(.form-select--searchable)').select2({
      minimumResultsForSearch: Infinity,
      placeholder: function () {
        return $(this).data('placeholder') || 'Select an option';
      },
    });
    $('.form-select--searchable').select2({
      placeholder: function () {
        return $(this).data('placeholder') || 'Select an option';
      },
    });
  }
  if (document.querySelector('.text-select')) {
    $('.text-select').select2({
      minimumResultsForSearch: Infinity,
      selectionCssClass: 'text-select-select',
      dropdownCssClass: 'text-select-dropdown',
      placeholder: function () {
        return $(this).data('placeholder') || 'Select an option';
      },
    });
  }
  if (document.querySelector('[data-bs-toggle="tooltip"]')) {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));
  }
});
